export default __webpack_public_path__ + "static/media/Jayasri@2x.a1a60a7a.jpeg";